import React from "react";
import { cn } from "../../lib/utils";
import { ChevronDown } from "lucide-react";

// A simple styled native select wrapper. 
// For more complex usage (radix-ui/headless ui) we would need more deps.
// This matches the user's current need for a prettier native select.

const Select = React.forwardRef(({ className, children, icon, ...props }, ref) => {
    return (
        <div className="relative">
            {icon && (
                <div className="absolute left-2.5 top-1/2 -translate-y-1/2 pointer-events-none text-gray-500">
                    {icon}
                </div>
            )}
            <select
                className={cn(
                    "flex h-9 w-full items-center justify-between rounded-md border border-white/10 bg-[#0a0e13] px-3 py-2 text-sm text-gray-300 placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-orange-500 disabled:cursor-not-allowed disabled:opacity-50 appearance-none",
                    icon ? "pl-9" : "",
                    className
                )}
                ref={ref}
                {...props}
            >
                {children}
            </select>
            <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 opacity-50 pointer-events-none" />
        </div>
    );
});
Select.displayName = "Select";

export { Select };
